import { render, staticRenderFns } from "./Japan.vue?vue&type=template&id=6dcd7036"
import script from "./Japan.vue?vue&type=script&lang=js"
export * from "./Japan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports